import Vue from 'vue'
import Vuetify from 'vuetify'
import colors from 'vuetify/lib/util/colors'
import 'vuetify/dist/vuetify.min.css'
import '@mdi/font/css/materialdesignicons.min.css'

Vue.use(Vuetify)

export default new Vuetify({
  icons: {
    iconfont: 'mdi'
  },

  theme: {
    options: { customProperties: true },
    themes: {
      light: {
        background: '#F4F5FA',
        primary: '#1971C2',
        error: '#E60000',
        pinkError: '#FCEBEA',
        success: '#0AA52C',
        warning: '#FF6F00',
        accent: colors.blueGrey.darken3,
        lightGrey: '#6C6C6C', //'#81939c',
        lightGrey1: '#F2F0F0',
        lightGrey2: '#F3F3F3',
        lightGrey3: '#F7F7F7',
        default: '#1971C2',
        greylighten1: '#A0A0A0',
        darkBlue: '#092A6D',
        lightBlue: '#EAF1FC',
        menu: colors.blueGrey.darken2,
        primaryBlack: '#1F1F1F',
        whiteBlack: '#FFF'
      },
      dark: {
        background: '#1F1F1F',
        primary: '#092A6D',
        error: '#E60000',
        pinkError: '#FCEBEA',
        success: '#0AA52C',
        warning: '#FF6F00',
        accent: '#AAA',
        lightGrey: '#6C6C6C', //'#81939c',
        lightGrey1: '#6C6C6C',
        lightGrey2: '#F3F3F3',
        lightGrey3: '#F7F7F7',
        default: '#092A6D',
        greylighten1: '#A0A0A0',
        darkBlue: '#092A6D',
        lightBlue: '#6C6C6C',
        menu: colors.blueGrey.darken2,
        primaryBlack: '#AAA',
        textStart: '#AAA',
        whiteBlack: '#2F2F2F'
      }
    }
  }
})
